<!--suppress ALL -->
<template>
  <div id="login" @keyup.enter="keyCodeLogin">
    <div class="box">
	  <p class="register lang">
	  	<el-select
	  	  class="lanselect"
	  	  v-model="language"
	  	  size="mini"
	  	  @change="changeLanguage()"
	  	>
	  	  <el-option v-for="(item,index) in langArr" :label="item.label" :value="item.value" :key="index"></el-option>
	  	</el-select>
	  </p>
      <p class="tip">{{$t("login_title")}}</p>
      <el-form id="loginForm" ref="loginForm" :model="loginForm" :rules="loginRule">
        <el-form-item class="input" prop="username" style="margin-top: .4rem">
          <el-input
            size="large"
            v-model="loginForm.username"
            :placeholder="$i18n.t('login_user_input')"
          >
            <i slot="prefix" class="iconfont icondaogouyuanx" style="margin-left: 0.05rem"></i>
          </el-input>
        </el-form-item>
        <el-form-item class="input" prop="password">
          <el-input
            size="large"
            v-model="loginForm.password"
            type="password"
            :placeholder="$i18n.t('login_pass_input')"
          >
            <i slot="prefix" class="iconfont iconmimax" style="margin-left: 0.05rem"></i>
          </el-input>
        </el-form-item>
		<el-checkbox class="checkbox" v-model="noneedLogin">{{$t("buchong").noneedlogin}}</el-checkbox>
        <el-button class="btn1" type="primary" @click="presubmit">{{$t("login_button")}}</el-button>
        <p class="register font14">
          <span @click="register" class="register2">{{$t("login_register")}}</span>
          <span class="forget font14" @click="forget">{{$t("login_forget")}}</span>
        </p>
      </el-form>
	  
    </div>
    <!-- <el-select
      class="lanselect"
      v-model="language"
      placeholder="中文"
      size="mini"
      @change="changeLanguage()"
    >
      <el-option label="中文" value="zh"></el-option>
      <el-option label="English" value="en"></el-option>
    </el-select> -->
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      centerDialogVisible: false,
      alertOpenIng: false,
      vcodeurl: "",
      loading: true,
	  noneedLogin: 1,
      loginForm: {
        username: null,
        password: null,
        client_id: "93dc94c23d83c2ca",
        app_type: "zmskin",
        code_token: null
      },
      loginRule: {
        username: [
          {
            required: true,
            message: this.$i18n.t("normal_notnull"),
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: this.$i18n.t("normal_notnull"),
            trigger: "blur"
          }
        ]
      },
      language: "zh",
	  langArr: []
    };
  },
  mounted() {
    this.language = localStorage.locale;
    if (localStorage.loginAccount) {
      this.loginForm.username = localStorage.loginAccount;
    }
	for (let i in this.langArrs){
		let obj = {
			label: this.langArrs[i],
			value: i
		}
		this.langArr.push(obj)
	}
	console.log(this.langArr)
  },
  methods: {
    changeLanguage() {
      localStorage.language = this.language
	  localStorage.locale = this.language
      location.reload()
    },
    forget() {
      this.$router.replace("/forget");
    },
    register() {
      this.$router.replace("/register");
    },
    presubmit() {
      let _this = this;
      this.$refs["loginForm"].validate(valid => {
        if (valid) {
          _this.submit();
        } else {
          console.log("error!");
          return false;
        }
      });
    },
    submit() {
      let _this = this;
      this.loginForm.code_token = -1;
      this.axios({
        method: "post",
        url: "/auth2/token",
        data: this.loginForm
      })
        .then(function(res) {
          console.log(res);
          if (res.data.code !== 0) {
            _this.$alert(res.data.msg, _this.$i18n.t("normal_tips"), {
              confirmButtonText: _this.$i18n.t("normal_sure")
            });
          } else {
            _this.unSetLocalStorage();
            localStorage.loginAccount = _this.loginForm.username;
            localStorage.access_token = res.data.access_token;
            _this.setCookie("access_token", res.data.access_token, "/", 100000);
            _this.$router.replace("/skinmgr/home");
          }
        })
        .catch(function(err) {
          if (err.msg) {
            _this.$alert(err.msg, _this.$i18n.t("normal_tips"), {
              confirmButtonText: _this.$i18n.t("normal_sure")
            });
          } else {
            _this.$alert(
              _this.$i18n.t("normal_networkerror"),
              _this.$i18n.t("normal_tips"),
              {
                confirmButtonText: _this.$i18n.t("normal_sure")
              }
            );
          }
        });
    },
    keyCodeLogin() {
      this.presubmit();
    }
  }
};
</script>

<style lang="scss">
#login {
  display: inline-block;
  height: 100%;
  width: 20.8vw;
  position: relative;
  z-index: 10;
  float: right;
  margin-right: 16.6vw;
  .box {
	position: absolute;
	width: 100%;
	height: 4.2rem;
	background-color: #fff;
	border-radius: 0.05rem;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	margin: auto;
    .el-input__inner {
      height: 0.416rem;
      border: none;
      border-bottom: 1px solid #ccc;
      border-radius: 0;
      padding-left: 0.3rem;
    }
    .el-dialog__body {
      height: 130px;
      padding: 0px 20px 20px;
    }
    .el-dialog__wrapper {
      position: absolute;
      top: -0.08rem;
    }
    .el-input--prefix .el-input__inner {
      padding-left: 0.28rem;
    }

    .tip {
      margin-top: 0.49rem;
      font-size: 0.25rem;
      letter-spacing: 0.051rem;
      color: #57AEC9;
      text-align: center;
    }
    .input {
      width: 15.6vw;
      height: 0.416rem;
      margin: 0.25rem auto;
      color: #bfbfbf;
      .iconfont {
        line-height: 0.416rem;
      }
    }
    .input1 {
      margin: 0.63rem auto 0;
    }
	.checkbox{
		width: 15.6vw;
		margin-left: 2.6vw;
	}
    .forget {
      color: #666666;
      float: right;
      font-size: 12px;
      cursor: pointer;
	  margin-top: 10px;
    }
    .forget:hover,
    .register:hover {
      text-decoration: none;
      color: #333;
    }
    #divblock {
      clear: both;
      display: block;
      width: 3.5rem;
      margin: 0.04rem auto 0;
      padding-top: 0.08rem;
      iframe {
        border: none;
        padding: 0px;
        margin: 0px;
        width: 257px;
        height: 128px;
      }
    }
    .btn1 {
      width: 15.6vw;
      height: 0.416rem;
      margin: 0.19rem 2.6vw 0.167rem;
      color: #fff;
      text-align: center;
      font-size: 0.167rem;
      background-color: #57AEC9;
      border: none;
    }
    .register {
	  width: 15.6vw;
      span {
        cursor: pointer;
      }
      color: #666666;
      text-align: left;
      font-size: 12px;
      margin: 0.1rem 2.6vw 0;
    }
    .register i {
      margin-left: 0.1rem;
    }
  }
  .lanselect {
    width: 0.7rem;
    height: 0.25rem;
	float: right;
  }
  p.register .el-input__inner{
	height: 0.25rem; 
	text-align: left;
	padding-left: 0.08rem;
	border: 1px solid #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue